// extracted by mini-css-extract-plugin
export default {"classes":"inactivityModal_classes__iN0Kk","btnDiv":"inactivityModal_btnDiv__uHhMR","bgRed":"inactivityModal_bgRed__O7TDl"};